import React from 'react';
import { observer } from 'mobx-react-lite';
import { Pagination, Typography } from '@mui/material';
import RESTCollectionModelBase from '@api/models/RESTCollectionModelBase';
import BasePagingInfoModel from '@models/BasePagingInfoModel';

interface BasePaginationProps {
    pagingInfo: BasePagingInfoModel;
    onPageChange: (pageNumber: number) => void;
}

const BasePagination: React.FC<BasePaginationProps> = observer(({ pagingInfo, onPageChange }) => {
    const handleOnChange = (event: React.ChangeEvent<unknown>, value: number) => {
        onPageChange(value)
    }

    return (
        <Pagination
            count={pagingInfo.totalPages}
            page={pagingInfo.pageNumber}
            onChange={handleOnChange}
            variant="outlined"
            shape="rounded"
            sx={{
                alignSelf: "center"
            }} />
    )
})

export default BasePagination;